import { PendingRequests } from '../components/requests';
import { useAuthStore } from '../store/authStore';

export function Requests() {
  const { hasAnyRole } = useAuthStore();
  const isManager = hasAnyRole('MANAGER');
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-4">
      <h1 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100">
        {isManager ? 'Assignment requests' : 'My requests'}
      </h1>
      <PendingRequests variant="inbox" view={isManager ? 'queue' : 'mine'} />
    </div>
  );
}
